import { render } from "./ClinicList.vue?vue&type=template&id=03e13ddc"
import script from "./ClinicList.vue?vue&type=script&lang=js"
export * from "./ClinicList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__